module.exports = __webpack_public_path__ + "img/wallet-icon-green.089cf1f3.svg";